import api from './index'
import { axios } from '@/utils/request'

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 *
 */
export function login (parameter) {
  console.log('parametorlogin',parameter);
  return axios({
    url: '/oauth/login',
    method: 'post',
    data: parameter
  })
}

export function getSmsCaptcha (parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter
  })
}

export function selectBirthDay(loginName) {
  return axios({
    url: `/oauth/selectBirthDay/${loginName}`,
    method: 'get',
  })
}

export function getFormToken(){
  return axios({
    url: `/oauth/${moduleName}/getFormToken`,
    method: 'get'
  })
}


export function getInfo () {
  return axios({
    url: '/ws/sys/userInfo',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function logout () {
  return axios({
    url: '/oauth/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
